import uuid from 'uuid';
import { setActiveBarber } from '../sale/actions';
import { redirectToRegister } from '../../main/payment/actions';
import { openChargeModal } from '../payment/reducer/chargeModal/actions';
import { UNASSIGNED_BARBER } from '../constants';
import { ADD_GIFT_CARD, UPDATE_GIFT_CARD } from '../order/constants';
import { addGiftCardItem } from '../order/actions';
import { t } from '../../../modules/infra/i18n';

const middleware = store => next => (action) => {
  switch (action.type) {
    case ADD_GIFT_CARD: {
      const barberId = action.payload.barberId || UNASSIGNED_BARBER;
      const item = {
        ...action.payload,
        id: uuid.v4(),
        name: t('register:gift_cards.item_name'),
        description: t('register:gift_cards.item_name'),
        cost: action.payload.amount,
        priceWithoutTaxes: action.payload.amount,
      };

      store.dispatch(addGiftCardItem(barberId, item));
      store.dispatch(setActiveBarber(barberId));
      store.dispatch(redirectToRegister());
      store.dispatch(openChargeModal());
      break;
    }

    case UPDATE_GIFT_CARD: {
      const barberId = action.payload.barberId || UNASSIGNED_BARBER;
      const item = {
        ...action.payload,
        cost: action.payload.amount,
        priceWithoutTaxes: action.payload.amount,
      };

      store.dispatch(addGiftCardItem(barberId, item));
      store.dispatch(setActiveBarber(barberId));
      store.dispatch(redirectToRegister());
      store.dispatch(openChargeModal());
      break;
    }

    default:
  }

  next(action);
};

export default middleware;
